import { LegalPageType } from "../../../../../api/types/translations";
import { useLanguage } from "../../../../../store/lang.context";
import classes from "./personalData.module.scss";

interface Props {
  translations: LegalPageType;
}

const PrivacyPolicy = ({ translations }: Props) => {
  const { language } = useLanguage();
  return (
    <div className={classes.container}>
      <div
        dangerouslySetInnerHTML={{
          __html: translations.results[0]["title_" + language],
        }}
      />
      <div
        dangerouslySetInnerHTML={{
          __html: translations.results[0]["subtitle_" + language],
        }}
      />
      <div className={classes.divider} />
      {translations.results[0].blocks.map((item) => (
        <>
          <div
            key={item.title}
            dangerouslySetInnerHTML={{ __html: item["title_" + language] }}
          />
          <div
            key={item.title}
            dangerouslySetInnerHTML={{ __html: item["subtitle_" + language] }}
          />
        </>
      ))}
    </div>
  );
};

export default PrivacyPolicy;
